import styled from 'styled-components';
import Text from 'components/Text';

export const Container = styled.div`
  width: 110px;
  display: flex;
  padding: 2px 0;
  margin: 4px 0 0;
  border-radius: 3px;
  background: #287C87;
  justify-content: center;
`;

export const TextAutoMapping = styled(Text).attrs({
  size: 10,
  color: "#FFFFFF"
})`
  text-align: center;
`;
